import {TEAM_PREFIX} from "data/constants/index";
import {TeamType} from "data/enums";
import {argosTheme} from "assets/theme/ARGOS";
import {elksTheme} from "assets/theme/ELKS";
import {lionsTheme} from "assets/theme/LIONS";
import {redblacksTheme} from "assets/theme/REDBLACKS";
import {alsTheme} from "assets/theme/ALS";
import {ticatsTheme} from "assets/theme/TICATS";
import {bombersTheme} from "assets/theme/BOMBERS";
import {stampsTheme} from "assets/theme/STAMPS";
import {ridersTheme} from "assets/theme/RIDERS";

export const theme = {
	[TeamType.ALS]: alsTheme,
	[TeamType.ARGOS]: argosTheme,
	[TeamType.BOMBERS]: bombersTheme,
	[TeamType.ELKS]: elksTheme,
	[TeamType.LIONS]: lionsTheme,
	[TeamType.REDBLACKS]: redblacksTheme,
	[TeamType.RIDERS]: ridersTheme,
	[TeamType.STAMPS]: stampsTheme,
	[TeamType.TICATS]: ticatsTheme,
}[TEAM_PREFIX];
